import httpUtil from "../assets/script/utils/http";

const state = {
  // tagName: "",
  tags: [],
  allDataCount: 0,
  //是否弹出绑定标签弹窗
  // dialogTagVisible: false
  // 是否显示详情
  isShowDetail: false,
  //详情主键Id
  id: 0,
  detailType: "",
  labelId: -999,
  article: {
    rowCount: 0,
    list: []
  },
  paragraph: {
    rowCount: 0,
    list: []
  },
  picture: {
    rowCount: 0,
    list: []
  },
  collect: {
    rowCount: 0,
    list: []
  },
  //数据主键
  detailId: 0,
  //是否弹出绑定标签弹窗
  dialogTagVisible: false,
  detailLableNameList: "",
  detailTag: "",
  pageHeight: 41,
  collectUpdate: false,
  docUpdate: false,
  useGuid: ""
};

const mutations = {
  AsetTags(state, payload) {
    state.tags = payload.dataSource;
    state.allDataCount = payload.allDataCount;
  },
  ///
  ASetDialogTagVisible(state, payload) {
    state.dialogTagVisible = payload.dialogTagVisible;
    state.detailTag = payload.detailTag;
    state.detailId = payload.detailId;
    state.detailLableNameList = payload.detailTag;
  },
  AsetArticleData(state, payload) {
    state.article.list = payload.dataSource;
    state.article.rowCount = payload.rowCount;
  },
  ASetDetailId(state, payload) {
    state.detailId = payload;
  },
  AUpdateArticleLabelNameList(state, payload) {
    state.article.list.forEach(m => {
      if (m.favoriteResourceId == payload.favoriteResourceId) {
        m.labelNameList = payload.labelNameList;
      }
    });
  },
  AUpdateParagraphLabelNameList(state, payload) {
    state.paragraph.list.forEach(m => {
      if (m.favoriteParagraphId == payload.favoriteParagraphId) {
        m.labelNameList = payload.labelNameList;
      }
    });
  },
  AUpdatePictureLabelNameList(state, payload) {
    state.picture.list.forEach(m => {
      if (m.favoriteImageId == payload.favoriteImageId) {
        m.labelNameList = payload.labelNameList;
      }
    });
  },
  AsetParagraphData(state, payload) {
    state.paragraph.list = payload.dataSource;
    state.paragraph.rowCount = payload.rowCount;
  },
  AsetPictureData(state, payload) {
    state.picture.list = payload.dataSource;
    state.picture.rowCount = payload.rowCount;
  },
  AsetlabelId(state, payload) {
    state.labelId = payload;
  },
  AsetDetailPop(state, payload) {
    state.isShowDetail = payload.isShowDetail;
    state.id = payload.id;
    state.detailType = payload.detailType;
  },
  AsetCollectData(state, payload) {
    state.collect.list = payload.dataSource;
    state.collect.rowCount = payload.rowCount;
  },
  AsetTagData(state, payload) {
    state.tags.forEach(m => {
      if (m.labelName === payload) {
        m.statCount--;
      }
    });
  },
  ASetCollectUpdate(state, payload) {
    state.collectUpdate = payload;
  },
  ASetDocUpdate(state, payload) {
    state.docUpdate = payload;
  },
  ASetUseGuid(state, guid) {
    state.useGuid = guid;
  }
};
const getters = {
  // statCount: (state) => {
  //   var total = 0;
  //   state.tags.forEach((m) => {
  //     total = total + m.statCount;
  //   });
  //   return total;
  // },
};

const actions = {
  ///查询标签
  ALabel(ctx, params) {
    return httpUtil.post("/ai/label", params);
  },
  ///数据绑定标签
  ALabelBind(ctx, params) {
    return httpUtil.post("/ai/labelbind", params);
  },
  //新增标签
  ALabelInsert(ctx, params) {
    return httpUtil.post("/ai/labelinsert", params);
  },
  //删除标签
  ALabelDel(ctx, params) {
    return httpUtil.post("/ai/labeldel", params);
  },
  //收藏文章列表
  AFavoriteResources(ctx, params) {
    return httpUtil.post("/ai/favoriteresources", params);
  },
  //收藏段落列表
  AFavoriteParagraph(ctx, params) {
    return httpUtil.post("/ai/FavoriteParagraphList", params);
  },
  //收藏图篇列表
  AFavoriteImagesList(ctx, params) {
    return httpUtil.post("/ai/FavoriteImagesList", params);
  },
  //取消收藏文章
  AFavoriteResourcesDel(ctx, params) {
    return httpUtil.post("/ai/FavoriteResourcesDel", params);
  },
  //取消收藏段落
  AFavoriteParagraphDel(ctx, params) {
    return httpUtil.post("/ai/FavoriteParagraphDel", params);
  },
  //取消收藏图片
  AFavoriteImagesDel(ctx, params) {
    return httpUtil.post("/ai/FavoriteImagesDel", params);
  },
  //收藏里的文章详情favoriteResourceId
  AFavoriteResourcesDetail(ctx, params) {
    return httpUtil.post("/ai/FavoriteResourcesDetail", params);
  },
  //收藏里的段落详情favoriteParagraphId
  AFavoriteParagraphDetail(ctx, params) {
    return httpUtil.post("/ai/FavoriteParagraphDetail", params);
  },
  //添加用户引用数据
  ADataQuoteInsert(ctx, params) {
    return httpUtil.post("/ai/DataQuoteInsert", params);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
